import { useBreakpoint } from './useBreakpoint'

export function useIsMobileViewport(
  initialValue: boolean | undefined = undefined
) {
  const isMobile = useBreakpoint('max', 'md', initialValue)
  return isMobile
}
